import React from 'react';

import classNames from 'clsx';

import { datesHaveSameDayMonthYear, formatDateShortDD } from '~/services/TimeService';

export interface RadioDatePickerDate {
  startDate: Date | string;
  endDate: Date | string;
  totalAvailable: number;
}

interface Props {
  date: RadioDatePickerDate;
  onSelectDate: (date: RadioDatePickerDate) => void;
  startDate?: Date | string | null;
}

const DateItem = ({ date, onSelectDate, startDate }: Props) => {
  const isBookable = date.totalAvailable > 0;
  const isSelected = startDate ? datesHaveSameDayMonthYear(date.startDate, startDate) : false;

  const classes = classNames('date', 'T-check-in', {
    disabled: !isBookable,
    'T-selected': isSelected,
  });
  return (
    <label className={classes}>
      <span className="radio-button">
        <input
          type="radio"
          onChange={() => {
            onSelectDate(date);
          }}
          name="tour-date"
          disabled={!isBookable}
          defaultChecked={isSelected}
        />
        <i />
      </span>
      <span className="inline-group">
        <div className="start-date-text">{formatDateShortDD(date.startDate)}</div>
        <div className="icon-arrow">
          <hr />
        </div>
        <div className="end-date-text">Ending on {formatDateShortDD(date.endDate)}</div>
      </span>
    </label>
  );
};

export default DateItem;
